import {all} from "redux-saga/effects";
import watchAddLives from "./addLives";
import watchBuyLives from "./buyLives";
import watchAdForLife from "./watchAdForLife";
import watchAdForCoins from "./watchAdForCoins";
import forkWithErrHandler from "../../../shared/utils/forkWithErrHandler";
import watchChangeProfile from "./changeProfile";

export default function* playerSaga() {
    yield all([
        forkWithErrHandler("playerSaga", "watchAddLives", watchAddLives),
        forkWithErrHandler("playerSaga", "watchBuyLives", watchBuyLives),
        forkWithErrHandler("playerSaga", "watchAdForLife", watchAdForLife),
        forkWithErrHandler("playerSaga", "watchAdForCoins", watchAdForCoins),
        forkWithErrHandler("playerSaga", "watchChangeProfile", watchChangeProfile),
    ]);
}